import React, { Component } from 'react';
import sha256 from 'sha256';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as userActions from '../_actions/user';
import * as buhtableActions from '../_actions/buhtable';

import Login from '../pages/Login';
import BuhTable from '../pages/BuhTable';

class App extends Component {

    componentDidMount() {
        //this.props.userAuthenticateCache()
    }

    render() { 
        const { isAuthenticated = false } = this.props;
        if(isAuthenticated) {
            return <BuhTable />
        };
        return <Login />
    }
};

const mapStateToProps = (state) => {
    const { token } = state.user;
    return {
        isAuthenticated: token,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators(userActions, dispatch),
        ...bindActionCreators(buhtableActions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/containers/App.jsx